import tesseraIconBlue from "../assets/branding/tessera-icon-blue.png";
import tesseraIconWhite from "../assets/branding/tessera-icon-white.png";
import tesseraLogoFull from "../assets/branding/tessera-logo-full.png";

/** Collapsed sidebar icon (from `public/Branding Images/Tessera Icon Logo Blue.png`). */
export const SIDEBAR_BRAND_LOGO_COLLAPSED_SRC = tesseraIconBlue;

/** Expanded sidebar logo (from `public/Branding Images/Tessera Logo Full High Quality.png`). */
export const SIDEBAR_BRAND_LOGO_EXPANDED_SRC = tesseraLogoFull;

/** Default brand mark for non-sidebar surfaces (e.g. loading states). */
export const SIDEBAR_BRAND_LOGO_SRC = tesseraIconBlue;

/** White mark for gradient surfaces (workspace account node). */
export const TESSERA_BRAND_LOGO_WHITE_SRC = tesseraIconWhite;

export const getSidebarBrandLogoSrc = (isCollapsed: boolean) =>
  isCollapsed ? SIDEBAR_BRAND_LOGO_COLLAPSED_SRC : SIDEBAR_BRAND_LOGO_EXPANDED_SRC;

export const SIDEBAR_BRAND_LOGO_COLLAPSED_SIZE = "40px";
export const SIDEBAR_BRAND_LOGO_EXPANDED_MAX_WIDTH = "236px";
export const SIDEBAR_BRAND_LOGO_EXPANDED_MAX_HEIGHT = "72px";
